import * as React from "react";
import { IQualifier } from "../../../model/formconfiguration/Qualifier";
import { Form } from "antd";
import {
  QualifierFormConstants,
  SelectComponent
} from "../../../common/Constants";
import { FormComponentProps } from "antd/lib/form";
import {} from "../../../common/Constants";
import SelectInput from "../../components/app/SelectInput";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";

export interface State {}

export interface SelectExistingQualifierFormProps extends FormComponentProps {
  translate: any;
  qualifiers?: IQualifier[];
  registerFormSubmitEventHandler?: any;
}

export default class SelectExistingQualifierForm extends React.Component<
  SelectExistingQualifierFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;

    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let newFormConfigSectionQualifier = {} as IFormConfigSectionQualifier;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormConfigSectionQualifier.qualifier = {
            ...newFormConfigSectionQualifier.qualifier,
            ...values
          };

          newFormConfigSectionQualifier.qualifier.description =
            values.qualifierDescription;

          newFormConfigSectionQualifier = {
            ...newFormConfigSectionQualifier,
            ...values,
            qualifierCode: values.code
          };
        }
      });
      return newFormConfigSectionQualifier;
    });
  }
  render() {
    const { translate, qualifiers } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Form.Item label={translate("qualifier_form.qualifier")}>
          {getFieldDecorator(QualifierFormConstants.Fields.CODE, {
            rules: [
              {
                required: true,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.qualifier")
                })
              }
            ]
          })(
            <SelectInput
              showSearch={true}
              placeholder={translate("qualifier_form.select_qualifier")}
              style={{ width: SelectComponent.WIDTH }}
              allowClear
              selectOptionKey={"code"}
              selectOptionValue={"name"}
              selectOptions={qualifiers}
              notFoundContent={translate("search.no_data")}
            />
          )}
        </Form.Item>
      </Form>
    );
  }
}
